import LocalizedStrings from 'react-localization';
import anand from '../assets/images/segments/AnandRam.png';
import duncan from '../assets/images/segments/DuncanMcCue.png';
import france from '../assets/images/segments/FranceBinette.png';
import kevan from '../assets/images/segments/KevanCheftel.png';
import MO from '../assets/images/segments/Marc-Olivier-Laramee.png';
import MB from '../assets/images/segments/MarcBarette.png';
import trish from '../assets/images/segments/PatriciaWilliams.png';
import pat from '../assets/images/segments/PatrickMasbourian.png';
import ratsamy from '../assets/images/segments/RatsamyPathammavong.png';
import sarah from '../assets/images/segments/SarahDuda.png';
import chloe from '../assets/images/segments/chloe.png';
import dominique from '../assets/images/segments/dominique.png';



let strings = new LocalizedStrings({

    en: {
        close: "Close",
        name:"Listening, learning, leading",
        content:"We are committed to creating space for learning, innovation and courageous conversations on topics related to equity, diversity, and inclusion.",
        content1: {
            video: "https://www.youtube.com/embed/yWv6ShMzde0",
            name: "Anand Ram",
            pronouns:"He/Him",
            role:"Producer, The National",
            content: "How do you track the diversity of people appearing in your content?",
            img: anand,
            tag: "Content (Programming)"
        },
        content2: {
            video: "https://www.youtube.com/embed/LCFwp3CvPUw",
            name: "Duncan McCue",
            pronouns:"He/Him",
            role:"Host - Cross Country Checkup, Correspondent - CBC The National",
            content: "What's being done to avoid biases in the coverage of Indigenous issues?",
            img: duncan,
            tag: "Indigenous matters"
        },
        content3: {
            video: "https://www.youtube.com/embed/TOgKUhaNI40",
            name: "Trish Williams",
            pronouns:"She/Her",
            role:"Executive Director. Scripted Content",
            content: "How do you support established and emerging creators from underrepresented communities?",
            img: trish,
            tag: "Content (Programming)"
        },
        content4: {
            video: "https://www.youtube.com/embed/mOkSRkOuUmY",
            name: "Sarah Duda",
            pronouns:"She/Her",
            role:"CBC Content Accessibility Lead",
            content: "How are you increasing the accessibility and usability of your content?",
            img: sarah,
            tag: "Content Accessibility"
        },
        content5: {
            video: "https://www.youtube.com/embed/vrExTeb_jwg",
            name: "Marc Barette",
            pronouns:"He/Him",
            role:"Director, Future of Work",
            content: "How will you ensure inclusion in teleworking and in a hybrid work model?",
            img: MB,
            tag: "Human Resources"
        },
        content6: {
            video: "https://www.youtube.com/embed/Q6xDLKahAYk",
            name: "Ratsamy Pathammavong",
            role:"Team Leader, Digital Development, Media",
            pronouns:"She/Her",
            content: "How are you responding to gender inequality in the tech industry?",
            img: ratsamy,
            tag: "Gender equity issues"
        },
        content8: {
            video: "",
            name: "Nadia Kidwai",
            role:"Executive Producer, Local",
            pronouns:"",
            content: "How are you promoting diversity and inclusion goals with your service providers?",
            img: "https://via.placeholder.com/150",
            tag: "Partnership"
        },
        content9: {
            video: "",
            name: "Faith Fundal",
            role:"(outCBC co-chair), Host - CBC Manitoba's afternoon show Up to Speed",
            pronouns:"They/Them",
            content: "How are you promoting diversity and inclusion goals with your service providers?",
            img: "https://via.placeholder.com/150",
            tag: "Partnership"
        },
        content10: {
            video: "",
            name: "Jeff Santos",
            role:"CBC Kids",
            pronouns:"",
            content: "How are you promoting diversity and inclusion goals with your service providers?",
            img: "https://via.placeholder.com/150",
            tag: "Partnership"
        },
    },
    fr: {
        close: "Fermer",
        name:"Écouter, apprendre, exercer un leadership",
        content:"Nous sommes résolus à créer un espace pour l’apprentissage, l’innovation et les conversations courageuses sur tous les sujets touchant l’équité, la diversité et l’inclusion.",
        content1: {
            video: "https://www.youtube.com/embed/z1FxSsAimBY",
            name: "Kevan Cheftel",
            pronouns:"Lui/Il",
            role:"Partenaire d'Affaires en Ressources Humaines",
            content: "Pour la gestion de vos ressources humaines, avez-vous des exemples de pratiques inclusives?",
            img: kevan,
            tag: "Ressources humaines"
        },
        content2: {
            video: "https://www.youtube.com/embed/RB0bfQ4VL7k",
            name: "Patrick Masbourian",
            pronouns:"",
            role:"Animateur à ICI PREMIÈRE, Tout un matin",
            content: "Pourquoi nommer l'identité culturelle ou ethnique des personnes invitées à votre émission?",
            img: pat,
            tag: "Équité raciale et ethnoculturelle"
        },
        content3: {
            video: "https://www.youtube.com/embed/vWGnr0hwSus",
            name: "Chloe Sondervost",
            pronouns:"Elle",
            role:"Réalisatrice à ICI PREMIÈRE (On dira ce qu'on voudra)",
            content: "Comment assurez-vous une meilleure représentativité parmi les personnes invitées sur vos ondes?",
            img: chloe,
            tag: "Contenu (programmation)"
        },
        content4: {
            video: "https://www.youtube.com/embed/d69HIqgEzg0",
            name: "Marc Barette",
            pronouns:"Lui/Il",
            role:"Directeur de projet, l'Avenir du travail",
            content: "Comment favorisez-vous l'inclusion dans un modèle de travail hybride?",
            img: MB,
            tag: "Ressources humaines"
        },
        content5: {
            video: "https://www.youtube.com/embed/V1Oo-9NEwcg",
            name: "Marc Olivier Laramee",
            pronouns:"Lui/Il",
            role:"Chef de projet de contenu audionumérique",
            content: "Quand écoutera-t-on en ondes une plus grande diversité d'accents francophones?",
            img: MO,
            tag: "Contenu (programmation)"
        },
        content6: {
            video: "https://www.youtube.com/embed/g0j-I4UOCV4",
            name: "Dominique Gagné",
            pronouns:"Elle",
            role:"Directrice, opérations numériques",
            content: "Que faites-vous en matière de pratiques d’accessibilité Web?",
            img: dominique,
            tag: "Accessibilité et situation de handicap"
        },
        content8: {
            video: "",
            name: "Mélissa Mollen Dupuis",
            pronouns:"",
            role:"Animatrice à ICI PREMIÈRE, Kuei! Kwe!",
            content: "",
            img: "https://via.placeholder.com/150",
            tag: "Partenariat"
        },
        content9: {
            video: "",
            name: "Karim Aït-Oumeziane",
            pronouns:"",
            role:"Rédacteur en chef",
            content: "",
            img: "https://via.placeholder.com/150",
            tag: "Partenariat"
        },
        content10: {
            video: "",
            name: "Nancy McLaughlin",
            pronouns:"",
            role:"(abilicrew), Design graphique",
            content: "",
            img: "https://via.placeholder.com/150",
            tag: "Partenariat"
        },

    }
});

export default strings;